import type { AudienceType } from "@/types/work";

/**
 * 表示モード（男性向け／女性向け）の保存・復元・適用をまとめたユーティリティ。
 * テーマカラーは index.css の CSS 変数（mode-male / mode-female）で切り替わるため、
 * ここでは html 要素の class を付け替えるだけでよい。
 */
export const MODE_STORAGE_KEY = "worksnavi:mode";

export function normalizeMode(value: string | null | undefined): AudienceType {
  return value === "female" ? "female" : "male";
}

export function readStoredMode(): AudienceType {
  if (typeof window === "undefined") return "male";
  try {
    return normalizeMode(window.localStorage.getItem(MODE_STORAGE_KEY));
  } catch {
    return "male";
  }
}

export function storeMode(mode: AudienceType): void {
  try {
    window.localStorage.setItem(MODE_STORAGE_KEY, mode);
  } catch {
    /* 保存できない環境ではセッション内のみ反映 */
  }
}

/** html 要素にモード class を適用する（CSS 変数が即座に切り替わる） */
export function applyModeClass(mode: AudienceType): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.classList.toggle("mode-female", mode === "female");
  root.classList.toggle("mode-male", mode === "male");
  root.dataset.mode = mode;
}

/** 初回描画前に保存済みモードを反映する */
export function initThemeFromStorage(): AudienceType {
  const mode = readStoredMode();
  applyModeClass(mode);
  return mode;
}